import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MultiSelectDropdownComponent } from '../../../components/multi-select-dropdown/multi-select-dropdown.component';
import { IndustryContentService } from '../../../shared/industry-content.service';
import { IndustryTagDto } from '../../../shared/types/IndustryTagDto';
import { IndustryContentModalWarningComponent } from '../industry-content-modal-warning/industry-content-modal-warning.component';

@Component({
  selector: 'lp2-industry-content-selector',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <lp2-multi-select-dropdown
      #multiSelectDropdown
      [hidden]="hidden"
      [modelType]="industryTagDto"
      [valueKey]="'id'"
      [labelKey]="'name'"
      [maxSelection]="3"
      [placeholder]="'industrycontent.selector.select' | translate"
      [options]="publishedIndustriesTags$ | async"
      [comingSoonOptions]="comingSoonIndustriesTags$ | async"
      [selectedOptions]="selectedIndustries$ | async"
      (selectionChange)="onSelectedIndustriesChange($event)"
      (maxItemsReached)="onMaxSelectedItemsReached()"
      (toggled)="onMultiSelectToggled($event)"
    ></lp2-multi-select-dropdown>
  `,
  styles: [
    `
      :host {
        display: block;
        min-width: 300px;
      }
    `,
  ],
})
export class IndustryContentSelectorComponent {
  @Input() hidden: boolean;
  @Output() toggled: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('multiSelectDropdown') multiSelectDropdown: MultiSelectDropdownComponent<IndustryTagDto>;

  industryTagDto: IndustryTagDto;
  publishedIndustriesTags$ = this.industryContentService.publishedIndustries$;
  comingSoonIndustriesTags$ = this.industryContentService.comingSoonIndustries$;
  selectedIndustries$ = this.industryContentService.selectedIndustries$;

  constructor(private industryContentService: IndustryContentService, private modalService: NgbModal) { }

  onMaxSelectedItemsReached() {
    this.modalService.open(IndustryContentModalWarningComponent, {
      windowClass: 'warning-modal',
      backdrop: 'static',
      keyboard: false,
    });
  }

  onSelectedIndustriesChange(selectedIndustries: IndustryTagDto[]) {
    this.industryContentService.saveSelectedIndustries(selectedIndustries);
  }

  onMultiSelectToggled(opened: boolean) {
    this.toggled.emit(opened);
  }

  open() {
    this.multiSelectDropdown.open();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/industry-content-section/industry-content-selector/industry-content-selector.component.ts